/* eslint-disable prettier/prettier */
import type { AdonisEndpoint } from '@tuyau/core/types'
import type { Registry } from './schema.d.ts'
import type { ApiDefinition } from './tree.d.ts'

const placeholder: any = {}

const routes = {
  'stores.fridge_stores': {
    methods: ["GET","HEAD"],
    pattern: '/stores/fridge-stores',
    tokens: [{"old":"/stores/fridge-stores","type":0,"val":"stores","end":""},{"old":"/stores/fridge-stores","type":0,"val":"fridge-stores","end":""}],
    types: placeholder as Registry['stores.fridge_stores']['types'],
  },
  'stores.show_actives_and_used_categories': {
    methods: ["GET","HEAD"],
    pattern: '/stores/:id/categories/actives-and-used',
    tokens: [{"old":"/stores/:id/categories/actives-and-used","type":0,"val":"stores","end":""},{"old":"/stores/:id/categories/actives-and-used","type":1,"val":"id","end":""},{"old":"/stores/:id/categories/actives-and-used","type":0,"val":"categories","end":""},{"old":"/stores/:id/categories/actives-and-used","type":0,"val":"actives-and-used","end":""}],
    types: placeholder as Registry['stores.show_actives_and_used_categories']['types'],
  },
  'stores.get_dashboard_kpis': {
    methods: ["GET","HEAD"],
    pattern: '/stores/get-all-kpis',
    tokens: [{"old":"/stores/get-all-kpis","type":0,"val":"stores","end":""},{"old":"/stores/get-all-kpis","type":0,"val":"get-all-kpis","end":""}],
    types: placeholder as Registry['stores.get_dashboard_kpis']['types'],
  },
  'stores.get_today_data': {
    methods: ["GET","HEAD"],
    pattern: '/stores/:id/today-datas',
    tokens: [{"old":"/stores/:id/today-datas","type":0,"val":"stores","end":""},{"old":"/stores/:id/today-datas","type":1,"val":"id","end":""},{"old":"/stores/:id/today-datas","type":0,"val":"today-datas","end":""}],
    types: placeholder as Registry['stores.get_today_data']['types'],
  },
  'stores.get_carts_data': {
    methods: ["GET","HEAD"],
    pattern: '/stores/:storeId/carts-data',
    tokens: [{"old":"/stores/:storeId/carts-data","type":0,"val":"stores","end":""},{"old":"/stores/:storeId/carts-data","type":1,"val":"storeId","end":""},{"old":"/stores/:storeId/carts-data","type":0,"val":"carts-data","end":""}],
    types: placeholder as Registry['stores.get_carts_data']['types'],
  },
  'stores.get_promo_codes_data': {
    methods: ["GET","HEAD"],
    pattern: '/stores/get-promos-datas/:dateStart/:dateEnd/:ids',
    tokens: [{"old":"/stores/get-promos-datas/:dateStart/:dateEnd/:ids","type":0,"val":"stores","end":""},{"old":"/stores/get-promos-datas/:dateStart/:dateEnd/:ids","type":0,"val":"get-promos-datas","end":""},{"old":"/stores/get-promos-datas/:dateStart/:dateEnd/:ids","type":1,"val":"dateStart","end":""},{"old":"/stores/get-promos-datas/:dateStart/:dateEnd/:ids","type":1,"val":"dateEnd","end":""},{"old":"/stores/get-promos-datas/:dateStart/:dateEnd/:ids","type":1,"val":"ids","end":""}],
    types: placeholder as Registry['stores.get_promo_codes_data']['types'],
  },
  'stores.index_checkin_kiosks': {
    methods: ["GET","HEAD"],
    pattern: '/stores/:storeId/checkins',
    tokens: [{"old":"/stores/:storeId/checkins","type":0,"val":"stores","end":""},{"old":"/stores/:storeId/checkins","type":1,"val":"storeId","end":""},{"old":"/stores/:storeId/checkins","type":0,"val":"checkins","end":""}],
    types: placeholder as Registry['stores.index_checkin_kiosks']['types'],
  },
  'stores.index_checkout_kiosks': {
    methods: ["GET","HEAD"],
    pattern: '/stores/:storeId/checkouts',
    tokens: [{"old":"/stores/:storeId/checkouts","type":0,"val":"stores","end":""},{"old":"/stores/:storeId/checkouts","type":1,"val":"storeId","end":""},{"old":"/stores/:storeId/checkouts","type":0,"val":"checkouts","end":""}],
    types: placeholder as Registry['stores.index_checkout_kiosks']['types'],
  },
  'products.show_minimum_stock': {
    methods: ["GET","HEAD"],
    pattern: '/products/:id/minimum-stock',
    tokens: [{"old":"/products/:id/minimum-stock","type":0,"val":"products","end":""},{"old":"/products/:id/minimum-stock","type":1,"val":"id","end":""},{"old":"/products/:id/minimum-stock","type":0,"val":"minimum-stock","end":""}],
    types: placeholder as Registry['products.show_minimum_stock']['types'],
  },
  'products.get_multiple_articles': {
    methods: ["GET","HEAD"],
    pattern: '/products/get-multiple-articles',
    tokens: [{"old":"/products/get-multiple-articles","type":0,"val":"products","end":""},{"old":"/products/get-multiple-articles","type":0,"val":"get-multiple-articles","end":""}],
    types: placeholder as Registry['products.get_multiple_articles']['types'],
  },
  'products.get_product_stock': {
    methods: ["GET","HEAD"],
    pattern: '/products/:reference/stock',
    tokens: [{"old":"/products/:reference/stock","type":0,"val":"products","end":""},{"old":"/products/:reference/stock","type":1,"val":"reference","end":""},{"old":"/products/:reference/stock","type":0,"val":"stock","end":""}],
    types: placeholder as Registry['products.get_product_stock']['types'],
  },
  'products.block_or_unblock_lots': {
    methods: ["POST"],
    pattern: '/products/handle-block-lots',
    tokens: [{"old":"/products/handle-block-lots","type":0,"val":"products","end":""},{"old":"/products/handle-block-lots","type":0,"val":"handle-block-lots","end":""}],
    types: placeholder as Registry['products.block_or_unblock_lots']['types'],
  },
  'products.add_comment_to_lots': {
    methods: ["POST"],
    pattern: '/products/comment-lots',
    tokens: [{"old":"/products/comment-lots","type":0,"val":"products","end":""},{"old":"/products/comment-lots","type":0,"val":"comment-lots","end":""}],
    types: placeholder as Registry['products.add_comment_to_lots']['types'],
  },
  'stores.get_lots_data': {
    methods: ["GET","HEAD"],
    pattern: '/quality/lots',
    tokens: [{"old":"/quality/lots","type":0,"val":"quality","end":""},{"old":"/quality/lots","type":0,"val":"lots","end":""}],
    types: placeholder as Registry['stores.get_lots_data']['types'],
  },
  'stores.get_articles_data': {
    methods: ["GET","HEAD"],
    pattern: '/quality/articles',
    tokens: [{"old":"/quality/articles","type":0,"val":"quality","end":""},{"old":"/quality/articles","type":0,"val":"articles","end":""}],
    types: placeholder as Registry['stores.get_articles_data']['types'],
  },
  'stores.get_lot_details': {
    methods: ["GET","HEAD"],
    pattern: '/quality/:lot',
    tokens: [{"old":"/quality/:lot","type":0,"val":"quality","end":""},{"old":"/quality/:lot","type":1,"val":"lot","end":""}],
    types: placeholder as Registry['stores.get_lot_details']['types'],
  },
  'carts.list_carts_with_images': {
    methods: ["GET","HEAD"],
    pattern: '/carts-with-images',
    tokens: [{"old":"/carts-with-images","type":0,"val":"carts-with-images","end":""}],
    types: placeholder as Registry['carts.list_carts_with_images']['types'],
  },
  'carts.get_images': {
    methods: ["GET","HEAD"],
    pattern: '/carts/:id/images',
    tokens: [{"old":"/carts/:id/images","type":0,"val":"carts","end":""},{"old":"/carts/:id/images","type":1,"val":"id","end":""},{"old":"/carts/:id/images","type":0,"val":"images","end":""}],
    types: placeholder as Registry['carts.get_images']['types'],
  },
  'carts.retrieve_cart': {
    methods: ["GET","HEAD"],
    pattern: '/carts/:id',
    tokens: [{"old":"/carts/:id","type":0,"val":"carts","end":""},{"old":"/carts/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['carts.retrieve_cart']['types'],
  },
  'carts.get_customer_info': {
    methods: ["GET","HEAD"],
    pattern: '/carts/:id/customer-info',
    tokens: [{"old":"/carts/:id/customer-info","type":0,"val":"carts","end":""},{"old":"/carts/:id/customer-info","type":1,"val":"id","end":""},{"old":"/carts/:id/customer-info","type":0,"val":"customer-info","end":""}],
    types: placeholder as Registry['carts.get_customer_info']['types'],
  },
  'sellers.index': {
    methods: ["GET","HEAD"],
    pattern: '/sellers',
    tokens: [{"old":"/sellers","type":0,"val":"sellers","end":""}],
    types: placeholder as Registry['sellers.index']['types'],
  },
  'sellers.show': {
    methods: ["GET","HEAD"],
    pattern: '/sellers/:id',
    tokens: [{"old":"/sellers/:id","type":0,"val":"sellers","end":""},{"old":"/sellers/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['sellers.show']['types'],
  },
  'stores.update_min_stock': {
    methods: ["PUT"],
    pattern: '/stores/:id/update-min-stock',
    tokens: [{"old":"/stores/:id/update-min-stock","type":0,"val":"stores","end":""},{"old":"/stores/:id/update-min-stock","type":1,"val":"id","end":""},{"old":"/stores/:id/update-min-stock","type":0,"val":"update-min-stock","end":""}],
    types: placeholder as Registry['stores.update_min_stock']['types'],
  },
  'stores.update_one_min_stock': {
    methods: ["PUT"],
    pattern: '/stores/:id/update-one-min-stock',
    tokens: [{"old":"/stores/:id/update-one-min-stock","type":0,"val":"stores","end":""},{"old":"/stores/:id/update-one-min-stock","type":1,"val":"id","end":""},{"old":"/stores/:id/update-one-min-stock","type":0,"val":"update-one-min-stock","end":""}],
    types: placeholder as Registry['stores.update_one_min_stock']['types'],
  },
  'stores.update_category_minimum_stock_compute': {
    methods: ["PUT"],
    pattern: '/stores/:id/compute-min-stock-values',
    tokens: [{"old":"/stores/:id/compute-min-stock-values","type":0,"val":"stores","end":""},{"old":"/stores/:id/compute-min-stock-values","type":1,"val":"id","end":""},{"old":"/stores/:id/compute-min-stock-values","type":0,"val":"compute-min-stock-values","end":""}],
    types: placeholder as Registry['stores.update_category_minimum_stock_compute']['types'],
  },
  'stores.get_store_categories_minimum_stock_computes': {
    methods: ["GET","HEAD"],
    pattern: '/stores/:id/compute-min-stock-values',
    tokens: [{"old":"/stores/:id/compute-min-stock-values","type":0,"val":"stores","end":""},{"old":"/stores/:id/compute-min-stock-values","type":1,"val":"id","end":""},{"old":"/stores/:id/compute-min-stock-values","type":0,"val":"compute-min-stock-values","end":""}],
    types: placeholder as Registry['stores.get_store_categories_minimum_stock_computes']['types'],
  },
  'stores.update_stream': {
    methods: ["PUT"],
    pattern: '/stores/:id/camera-streams',
    tokens: [{"old":"/stores/:id/camera-streams","type":0,"val":"stores","end":""},{"old":"/stores/:id/camera-streams","type":1,"val":"id","end":""},{"old":"/stores/:id/camera-streams","type":0,"val":"camera-streams","end":""}],
    types: placeholder as Registry['stores.update_stream']['types'],
  },
  'store_camera_configs.list_unify_hosts': {
    methods: ["GET","HEAD"],
    pattern: '/stores/camera-streams/unify-hosts',
    tokens: [{"old":"/stores/camera-streams/unify-hosts","type":0,"val":"stores","end":""},{"old":"/stores/camera-streams/unify-hosts","type":0,"val":"camera-streams","end":""},{"old":"/stores/camera-streams/unify-hosts","type":0,"val":"unify-hosts","end":""}],
    types: placeholder as Registry['store_camera_configs.list_unify_hosts']['types'],
  },
  'store_camera_configs.sync_unify_cameras': {
    methods: ["POST"],
    pattern: '/stores/:id/camera-streams/unify-hosts/:hostId/sync',
    tokens: [{"old":"/stores/:id/camera-streams/unify-hosts/:hostId/sync","type":0,"val":"stores","end":""},{"old":"/stores/:id/camera-streams/unify-hosts/:hostId/sync","type":1,"val":"id","end":""},{"old":"/stores/:id/camera-streams/unify-hosts/:hostId/sync","type":0,"val":"camera-streams","end":""},{"old":"/stores/:id/camera-streams/unify-hosts/:hostId/sync","type":0,"val":"unify-hosts","end":""},{"old":"/stores/:id/camera-streams/unify-hosts/:hostId/sync","type":1,"val":"hostId","end":""},{"old":"/stores/:id/camera-streams/unify-hosts/:hostId/sync","type":0,"val":"sync","end":""}],
    types: placeholder as Registry['store_camera_configs.sync_unify_cameras']['types'],
  },
  'store_camera_configs.restart_camera_runtime': {
    methods: ["POST"],
    pattern: '/stores/:id/camera-runtime/restart',
    tokens: [{"old":"/stores/:id/camera-runtime/restart","type":0,"val":"stores","end":""},{"old":"/stores/:id/camera-runtime/restart","type":1,"val":"id","end":""},{"old":"/stores/:id/camera-runtime/restart","type":0,"val":"camera-runtime","end":""},{"old":"/stores/:id/camera-runtime/restart","type":0,"val":"restart","end":""}],
    types: placeholder as Registry['store_camera_configs.restart_camera_runtime']['types'],
  },
  'store_camera_configs.create_store_camera_view_session': {
    methods: ["GET","HEAD"],
    pattern: '/stores/:id/camera-view-session',
    tokens: [{"old":"/stores/:id/camera-view-session","type":0,"val":"stores","end":""},{"old":"/stores/:id/camera-view-session","type":1,"val":"id","end":""},{"old":"/stores/:id/camera-view-session","type":0,"val":"camera-view-session","end":""}],
    types: placeholder as Registry['store_camera_configs.create_store_camera_view_session']['types'],
  },
  'store_camera_configs.set_camera_record_on_pre_auth': {
    methods: ["PATCH"],
    pattern: '/stores/:id/cameras/:cameraId/record-on-pre-auth',
    tokens: [{"old":"/stores/:id/cameras/:cameraId/record-on-pre-auth","type":0,"val":"stores","end":""},{"old":"/stores/:id/cameras/:cameraId/record-on-pre-auth","type":1,"val":"id","end":""},{"old":"/stores/:id/cameras/:cameraId/record-on-pre-auth","type":0,"val":"cameras","end":""},{"old":"/stores/:id/cameras/:cameraId/record-on-pre-auth","type":1,"val":"cameraId","end":""},{"old":"/stores/:id/cameras/:cameraId/record-on-pre-auth","type":0,"val":"record-on-pre-auth","end":""}],
    types: placeholder as Registry['store_camera_configs.set_camera_record_on_pre_auth']['types'],
  },
  'sellers.store': {
    methods: ["POST"],
    pattern: '/sellers',
    tokens: [{"old":"/sellers","type":0,"val":"sellers","end":""}],
    types: placeholder as Registry['sellers.store']['types'],
  },
  'sellers.update': {
    methods: ["PATCH"],
    pattern: '/sellers/:id',
    tokens: [{"old":"/sellers/:id","type":0,"val":"sellers","end":""},{"old":"/sellers/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['sellers.update']['types'],
  },
  'sellers.destroy': {
    methods: ["DELETE"],
    pattern: '/sellers/:id',
    tokens: [{"old":"/sellers/:id","type":0,"val":"sellers","end":""},{"old":"/sellers/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['sellers.destroy']['types'],
  },
  'stores.get_cpi_kiosks': {
    methods: ["GET","HEAD"],
    pattern: '/stores/cpi-kiosks/:reference',
    tokens: [{"old":"/stores/cpi-kiosks/:reference","type":0,"val":"stores","end":""},{"old":"/stores/cpi-kiosks/:reference","type":0,"val":"cpi-kiosks","end":""},{"old":"/stores/cpi-kiosks/:reference","type":1,"val":"reference","end":""}],
    types: placeholder as Registry['stores.get_cpi_kiosks']['types'],
  },
  'admins.list_api_keys': {
    methods: ["GET","HEAD"],
    pattern: '/admins/:adminId/api-keys',
    tokens: [{"old":"/admins/:adminId/api-keys","type":0,"val":"admins","end":""},{"old":"/admins/:adminId/api-keys","type":1,"val":"adminId","end":""},{"old":"/admins/:adminId/api-keys","type":0,"val":"api-keys","end":""}],
    types: placeholder as Registry['admins.list_api_keys']['types'],
  },
  'admins.generate_api_key': {
    methods: ["POST"],
    pattern: '/admins/:adminId/api-keys',
    tokens: [{"old":"/admins/:adminId/api-keys","type":0,"val":"admins","end":""},{"old":"/admins/:adminId/api-keys","type":1,"val":"adminId","end":""},{"old":"/admins/:adminId/api-keys","type":0,"val":"api-keys","end":""}],
    types: placeholder as Registry['admins.generate_api_key']['types'],
  },
  'admins.revoke_api_key': {
    methods: ["DELETE"],
    pattern: '/admins/:adminId/api-keys/:apiKeyId',
    tokens: [{"old":"/admins/:adminId/api-keys/:apiKeyId","type":0,"val":"admins","end":""},{"old":"/admins/:adminId/api-keys/:apiKeyId","type":1,"val":"adminId","end":""},{"old":"/admins/:adminId/api-keys/:apiKeyId","type":0,"val":"api-keys","end":""},{"old":"/admins/:adminId/api-keys/:apiKeyId","type":1,"val":"apiKeyId","end":""}],
    types: placeholder as Registry['admins.revoke_api_key']['types'],
  },
  'carts.compute': {
    methods: ["POST"],
    pattern: '/carts/compute/:id?',
    tokens: [{"old":"/carts/compute/:id?","type":0,"val":"carts","end":""},{"old":"/carts/compute/:id?","type":0,"val":"compute","end":""},{"old":"/carts/compute/:id?","type":3,"val":"id","end":""}],
    types: placeholder as Registry['carts.compute']['types'],
  },
  'carts.cancel': {
    methods: ["POST"],
    pattern: '/carts/cancel/:id',
    tokens: [{"old":"/carts/cancel/:id","type":0,"val":"carts","end":""},{"old":"/carts/cancel/:id","type":0,"val":"cancel","end":""},{"old":"/carts/cancel/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['carts.cancel']['types'],
  },
  'carts.validate': {
    methods: ["POST"],
    pattern: '/carts/validate/:id',
    tokens: [{"old":"/carts/validate/:id","type":0,"val":"carts","end":""},{"old":"/carts/validate/:id","type":0,"val":"validate","end":""},{"old":"/carts/validate/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['carts.validate']['types'],
  },
  'carts.article_history': {
    methods: ["POST"],
    pattern: '/articles/history',
    tokens: [{"old":"/articles/history","type":0,"val":"articles","end":""},{"old":"/articles/history","type":0,"val":"history","end":""}],
    types: placeholder as Registry['carts.article_history']['types'],
  },
  'carts.advanced_article_infos': {
    methods: ["POST"],
    pattern: '/articles/advanced-infos',
    tokens: [{"old":"/articles/advanced-infos","type":0,"val":"articles","end":""},{"old":"/articles/advanced-infos","type":0,"val":"advanced-infos","end":""}],
    types: placeholder as Registry['carts.advanced_article_infos']['types'],
  },
  'staging_tools.get_test_account': {
    methods: ["GET","HEAD"],
    pattern: '/staging-tools/test-account',
    tokens: [{"old":"/staging-tools/test-account","type":0,"val":"staging-tools","end":""},{"old":"/staging-tools/test-account","type":0,"val":"test-account","end":""}],
    types: placeholder as Registry['staging_tools.get_test_account']['types'],
  },
  'staging_tools.toggle_test_account': {
    methods: ["POST"],
    pattern: '/staging-tools/test-account/toggle',
    tokens: [{"old":"/staging-tools/test-account/toggle","type":0,"val":"staging-tools","end":""},{"old":"/staging-tools/test-account/toggle","type":0,"val":"test-account","end":""},{"old":"/staging-tools/test-account/toggle","type":0,"val":"toggle","end":""}],
    types: placeholder as Registry['staging_tools.toggle_test_account']['types'],
  },
  'staging_tools.generate_test_account_qrcode': {
    methods: ["POST"],
    pattern: '/staging-tools/test-account/qrcode',
    tokens: [{"old":"/staging-tools/test-account/qrcode","type":0,"val":"staging-tools","end":""},{"old":"/staging-tools/test-account/qrcode","type":0,"val":"test-account","end":""},{"old":"/staging-tools/test-account/qrcode","type":0,"val":"qrcode","end":""}],
    types: placeholder as Registry['staging_tools.generate_test_account_qrcode']['types'],
  },
  'forecast.forecast_stores': {
    methods: ["GET","HEAD"],
    pattern: '/forecast/stores',
    tokens: [{"old":"/forecast/stores","type":0,"val":"forecast","end":""},{"old":"/forecast/stores","type":0,"val":"stores","end":""}],
    types: placeholder as Registry['forecast.forecast_stores']['types'],
  },
  'forecast.forecast_store': {
    methods: ["GET","HEAD"],
    pattern: '/forecast/stores/:id',
    tokens: [{"old":"/forecast/stores/:id","type":0,"val":"forecast","end":""},{"old":"/forecast/stores/:id","type":0,"val":"stores","end":""},{"old":"/forecast/stores/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['forecast.forecast_store']['types'],
  },
  'forecast.backtest_store': {
    methods: ["GET","HEAD"],
    pattern: '/forecast/stores/:id/backtest',
    tokens: [{"old":"/forecast/stores/:id/backtest","type":0,"val":"forecast","end":""},{"old":"/forecast/stores/:id/backtest","type":0,"val":"stores","end":""},{"old":"/forecast/stores/:id/backtest","type":1,"val":"id","end":""},{"old":"/forecast/stores/:id/backtest","type":0,"val":"backtest","end":""}],
    types: placeholder as Registry['forecast.backtest_store']['types'],
  },
  'forecast.backtest_aggregate': {
    methods: ["GET","HEAD"],
    pattern: '/forecast/backtest-aggregate',
    tokens: [{"old":"/forecast/backtest-aggregate","type":0,"val":"forecast","end":""},{"old":"/forecast/backtest-aggregate","type":0,"val":"backtest-aggregate","end":""}],
    types: placeholder as Registry['forecast.backtest_aggregate']['types'],
  },
  'forecast.store_typologies': {
    methods: ["GET","HEAD"],
    pattern: '/forecast/store-typologies',
    tokens: [{"old":"/forecast/store-typologies","type":0,"val":"forecast","end":""},{"old":"/forecast/store-typologies","type":0,"val":"store-typologies","end":""}],
    types: placeholder as Registry['forecast.store_typologies']['types'],
  },
  'stores.update_kpis': {
    methods: ["POST"],
    pattern: '/sync/update-store-kpis',
    tokens: [{"old":"/sync/update-store-kpis","type":0,"val":"sync","end":""},{"old":"/sync/update-store-kpis","type":0,"val":"update-store-kpis","end":""}],
    types: placeholder as Registry['stores.update_kpis']['types'],
  },
  'reappro_category_groups.index': {
    methods: ["GET","HEAD"],
    pattern: '/reappro-category-groups',
    tokens: [{"old":"/reappro-category-groups","type":0,"val":"reappro-category-groups","end":""}],
    types: placeholder as Registry['reappro_category_groups.index']['types'],
  },
  'reappro_category_groups.store': {
    methods: ["POST"],
    pattern: '/reappro-category-groups',
    tokens: [{"old":"/reappro-category-groups","type":0,"val":"reappro-category-groups","end":""}],
    types: placeholder as Registry['reappro_category_groups.store']['types'],
  },
  'reappro_category_groups.update': {
    methods: ["PATCH"],
    pattern: '/reappro-category-groups/:id',
    tokens: [{"old":"/reappro-category-groups/:id","type":0,"val":"reappro-category-groups","end":""},{"old":"/reappro-category-groups/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['reappro_category_groups.update']['types'],
  },
  'reappro_category_groups.destroy': {
    methods: ["DELETE"],
    pattern: '/reappro-category-groups/:id',
    tokens: [{"old":"/reappro-category-groups/:id","type":0,"val":"reappro-category-groups","end":""},{"old":"/reappro-category-groups/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['reappro_category_groups.destroy']['types'],
  },
  'opening_sessions.index': {
    methods: ["GET","HEAD"],
    pattern: '/opening-sessions',
    tokens: [{"old":"/opening-sessions","type":0,"val":"opening-sessions","end":""}],
    types: placeholder as Registry['opening_sessions.index']['types'],
  },
  'opening_sessions.get_recordings': {
    methods: ["GET","HEAD"],
    pattern: '/opening-sessions/:sessionId/recordings',
    tokens: [{"old":"/opening-sessions/:sessionId/recordings","type":0,"val":"opening-sessions","end":""},{"old":"/opening-sessions/:sessionId/recordings","type":1,"val":"sessionId","end":""},{"old":"/opening-sessions/:sessionId/recordings","type":0,"val":"recordings","end":""}],
    types: placeholder as Registry['opening_sessions.get_recordings']['types'],
  },
  'opening_sessions.retain': {
    methods: ["POST"],
    pattern: '/opening-sessions/:id/retain',
    tokens: [{"old":"/opening-sessions/:id/retain","type":0,"val":"opening-sessions","end":""},{"old":"/opening-sessions/:id/retain","type":1,"val":"id","end":""},{"old":"/opening-sessions/:id/retain","type":0,"val":"retain","end":""}],
    types: placeholder as Registry['opening_sessions.retain']['types'],
  },
  'stores.index': {
    methods: ["GET","HEAD"],
    pattern: '/stores',
    tokens: [{"old":"/stores","type":0,"val":"stores","end":""}],
    types: placeholder as Registry['stores.index']['types'],
  },
  'stores.show': {
    methods: ["GET","HEAD"],
    pattern: '/stores/:id',
    tokens: [{"old":"/stores/:id","type":0,"val":"stores","end":""},{"old":"/stores/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['stores.show']['types'],
  },
  'stores.store': {
    methods: ["POST"],
    pattern: '/stores',
    tokens: [{"old":"/stores","type":0,"val":"stores","end":""}],
    types: placeholder as Registry['stores.store']['types'],
  },
  'stores.update': {
    methods: ["PUT","PATCH"],
    pattern: '/stores/:id',
    tokens: [{"old":"/stores/:id","type":0,"val":"stores","end":""},{"old":"/stores/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['stores.update']['types'],
  },
  'contacts.index': {
    methods: ["GET","HEAD"],
    pattern: '/contacts',
    tokens: [{"old":"/contacts","type":0,"val":"contacts","end":""}],
    types: placeholder as Registry['contacts.index']['types'],
  },
  'contacts.store': {
    methods: ["POST"],
    pattern: '/contacts',
    tokens: [{"old":"/contacts","type":0,"val":"contacts","end":""}],
    types: placeholder as Registry['contacts.store']['types'],
  },
  'contacts.update': {
    methods: ["PATCH"],
    pattern: '/contacts/:id',
    tokens: [{"old":"/contacts/:id","type":0,"val":"contacts","end":""},{"old":"/contacts/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['contacts.update']['types'],
  },
  'contacts.destroy': {
    methods: ["DELETE"],
    pattern: '/contacts/:id',
    tokens: [{"old":"/contacts/:id","type":0,"val":"contacts","end":""},{"old":"/contacts/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['contacts.destroy']['types'],
  },
  'interest_zone_runs.index': {
    methods: ["GET","HEAD"],
    pattern: '/interest-zone-runs',
    tokens: [{"old":"/interest-zone-runs","type":0,"val":"interest-zone-runs","end":""}],
    types: placeholder as Registry['interest_zone_runs.index']['types'],
  },
  'interest_zone_runs.store': {
    methods: ["POST"],
    pattern: '/interest-zone-runs',
    tokens: [{"old":"/interest-zone-runs","type":0,"val":"interest-zone-runs","end":""}],
    types: placeholder as Registry['interest_zone_runs.store']['types'],
  },
  'interest_zone_runs.show': {
    methods: ["GET","HEAD"],
    pattern: '/interest-zone-runs/:key',
    tokens: [{"old":"/interest-zone-runs/:key","type":0,"val":"interest-zone-runs","end":""},{"old":"/interest-zone-runs/:key","type":1,"val":"key","end":""}],
    types: placeholder as Registry['interest_zone_runs.show']['types'],
  },
  'interest_zone_runs.destroy': {
    methods: ["DELETE"],
    pattern: '/interest-zone-runs/:key',
    tokens: [{"old":"/interest-zone-runs/:key","type":0,"val":"interest-zone-runs","end":""},{"old":"/interest-zone-runs/:key","type":1,"val":"key","end":""}],
    types: placeholder as Registry['interest_zone_runs.destroy']['types'],
  },
  'interest_zone_saved_maps.index': {
    methods: ["GET","HEAD"],
    pattern: '/interest-zone-saved-maps',
    tokens: [{"old":"/interest-zone-saved-maps","type":0,"val":"interest-zone-saved-maps","end":""}],
    types: placeholder as Registry['interest_zone_saved_maps.index']['types'],
  },
  'interest_zone_saved_maps.store': {
    methods: ["POST"],
    pattern: '/interest-zone-saved-maps',
    tokens: [{"old":"/interest-zone-saved-maps","type":0,"val":"interest-zone-saved-maps","end":""}],
    types: placeholder as Registry['interest_zone_saved_maps.store']['types'],
  },
  'interest_zone_saved_maps.show': {
    methods: ["GET","HEAD"],
    pattern: '/interest-zone-saved-maps/:id',
    tokens: [{"old":"/interest-zone-saved-maps/:id","type":0,"val":"interest-zone-saved-maps","end":""},{"old":"/interest-zone-saved-maps/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['interest_zone_saved_maps.show']['types'],
  },
  'interest_zone_saved_maps.update': {
    methods: ["PATCH"],
    pattern: '/interest-zone-saved-maps/:id',
    tokens: [{"old":"/interest-zone-saved-maps/:id","type":0,"val":"interest-zone-saved-maps","end":""},{"old":"/interest-zone-saved-maps/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['interest_zone_saved_maps.update']['types'],
  },
  'interest_zone_saved_maps.destroy': {
    methods: ["DELETE"],
    pattern: '/interest-zone-saved-maps/:id',
    tokens: [{"old":"/interest-zone-saved-maps/:id","type":0,"val":"interest-zone-saved-maps","end":""},{"old":"/interest-zone-saved-maps/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['interest_zone_saved_maps.destroy']['types'],
  },
  'interest_zone_saved_maps.add_zones': {
    methods: ["POST"],
    pattern: '/interest-zone-saved-maps/:id/zones',
    tokens: [{"old":"/interest-zone-saved-maps/:id/zones","type":0,"val":"interest-zone-saved-maps","end":""},{"old":"/interest-zone-saved-maps/:id/zones","type":1,"val":"id","end":""},{"old":"/interest-zone-saved-maps/:id/zones","type":0,"val":"zones","end":""}],
    types: placeholder as Registry['interest_zone_saved_maps.add_zones']['types'],
  },
  'interest_zone_saved_maps.remove_zone': {
    methods: ["DELETE"],
    pattern: '/interest-zone-saved-maps/:id/zones/:zoneId',
    tokens: [{"old":"/interest-zone-saved-maps/:id/zones/:zoneId","type":0,"val":"interest-zone-saved-maps","end":""},{"old":"/interest-zone-saved-maps/:id/zones/:zoneId","type":1,"val":"id","end":""},{"old":"/interest-zone-saved-maps/:id/zones/:zoneId","type":0,"val":"zones","end":""},{"old":"/interest-zone-saved-maps/:id/zones/:zoneId","type":1,"val":"zoneId","end":""}],
    types: placeholder as Registry['interest_zone_saved_maps.remove_zone']['types'],
  },
} as const satisfies Record<string, AdonisEndpoint>

export { routes }

export const registry = {
  routes,
  $tree: {} as ApiDefinition,
}

declare module '@tuyau/core/types' {
  export interface UserRegistry {
    routes: typeof routes
    $tree: ApiDefinition
  }
}
